<div class="n-oldalfej">
  <div>
    <h2>Bérösszesítő (adott időszakra)</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · {{ idoszakNev }} · a tárolt számfejtésekből</span>
  </div>
  <div class="spacer"></div>
  <ion-button (click)="csv()" [disabled]="!adat?.sorok?.length"><ion-icon slot="start" name="download-outline"></ion-icon>CSV</ion-button>
  <ion-button (click)="nyomtat()" [disabled]="!adat?.sorok?.length"><ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="n-szuro-sor">
    <label>Hónaptól
      <span class="as-idoszak">
        <select [(ngModel)]="tolEv" (ngModelChange)="betolt()"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
        <select [(ngModel)]="tolHo" (ngModelChange)="betolt()"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
      </span>
    </label>
    <label>hónapig
      <span class="as-idoszak">
        <select [(ngModel)]="igEv" (ngModelChange)="betolt()"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
        <select [(ngModel)]="igHo" (ngModelChange)="betolt()"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
      </span>
    </label>
    <span class="as-gyors">
      <button type="button" class="ov-gomb halvany-gomb" (click)="gyors('ev')">{{ aktiv.ev }}</button>
      <button type="button" class="ov-gomb halvany-gomb" (click)="gyors('elozo')">{{ aktiv.ev - 1 }}</button>
      <button type="button" class="ov-gomb halvany-gomb" (click)="gyors('12')" title="Az aktív hónappal záruló 12 hónap">Utolsó 12 hónap</button>
    </span>
    <label>Bontás
      <select [(ngModel)]="csoport" (ngModelChange)="betolt()"><option *ngFor="let c of csoportok" [ngValue]="c.k">{{ c.c }}</option></select>
    </label>
    <label class="as-kapcs"><input type="checkbox" [(ngModel)]="csakVegleges" (ngModelChange)="betolt()"> csak véglegesített</label>
    <span class="spacer"></span>
    <span class="cimke sarga" *ngIf="adat?.tervezet_db">{{ adat.tervezet_db }} számfejtés még tervezet</span>
    <span class="cimke" *ngIf="adat?.kimaradt_ev_db" title="Az egyéni vállalkozó (átalányadós) elszámolása nem bér – az Átalányadós képernyőn van">{{ adat.kimaradt_ev_db }} egyéni vállalkozói számfejtés kimaradt</span>
  </div>

  <div class="as-figyel" *ngIf="forditott">
    <span class="cimke piros">A kezdő hónap későbbi a záró hónapnál.</span>
  </div>

  <ng-container *ngIf="adat">
    <div class="ata-kpi as-kpi">
      <div class="n-panel ata-k"><span>Bruttó bér</span><b>{{ adat.osszesen.brutto | number:'1.0-0' }} Ft</b>
        <small>{{ adat.osszesen.fo }} fő · {{ adat.osszesen.honap }} hónap · {{ adat.osszesen.db }} számfejtés</small></div>
      <div class="n-panel ata-k"><span>Munkavállalói levonások</span><b>{{ (adat.osszesen.szja + adat.osszesen.tb_jarulek) | number:'1.0-0' }} Ft</b>
        <small>SZJA {{ adat.osszesen.szja | number:'1.0-0' }} · TB {{ adat.osszesen.tb_jarulek | number:'1.0-0' }}</small></div>
      <div class="n-panel ata-k"><span>Nettó</span><b>{{ adat.osszesen.netto | number:'1.0-0' }} Ft</b>
        <small>letiltás {{ adat.osszesen.letiltas | number:'1.0-0' }}<ng-container *ngIf="adat.osszesen.egyeb_levonas"> · egyéb levonás {{ adat.osszesen.egyeb_levonas | number:'1.0-0' }}</ng-container></small></div>
      <div class="n-panel ata-k ata-teher"><span>Munkáltatói összköltség</span><b>{{ adat.osszesen.koltseg | number:'1.0-0' }} Ft</b>
        <small><ng-container *ngIf="adat.osszesen.szocho_13 || !adat.osszesen.kiva">szocho {{ adat.osszesen.szocho_13 | number:'1.0-0' }}</ng-container><ng-container *ngIf="adat.osszesen.kiva"> KIVA {{ adat.osszesen.kiva | number:'1.0-0' }}</ng-container></small></div>
    </div>

    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th *ngFor="let o of oszlopok" [class]="(o.num ? 'num ' : '') + (o.cs || '')">{{ o.c }}</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of adat.sorok">
            <td *ngFor="let o of oszlopok" [class]="(o.num ? 'num ' : '') + (o.cs || '')">
              <ng-container *ngIf="o.k === 'cim'"><b>{{ s.cim }}</b><span class="halvany" *ngIf="s.alcim"> · {{ s.alcim }}</span></ng-container>
              <ng-container *ngIf="o.k !== 'cim'">{{ ertek(s, o) }}</ng-container>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="adat.sorok.length"><tr>
          <td *ngFor="let o of oszlopok" [class]="(o.num ? 'num ' : '') + (o.cs || '')">{{ o.k === 'cim' ? 'Összesen' : ertek(adat.osszesen, o) }}</td>
        </tr></tfoot>
      </table>
      <div class="ures" *ngIf="!adat.sorok.length"><ion-icon name="document-outline"></ion-icon>Ebben az időszakban nincs {{ csakVegleges ? 'véglegesített ' : '' }}számfejtés.</div>

    <!-- KIVETT SZABADSÁGOK (ber-szabadsag.js): a záró év kerete, az időszakban és az évben kivett napok -->
    <div class="n-panel as-szab" *ngIf="adat.szabadsag?.sorok?.length">
      <div class="n-panel-cim">Szabadságok – {{ adat.szabadsag.ev }} <span class="n-alcim">· napokban; az időszak: {{ adat.szabadsag.tol_ho }}–{{ adat.szabadsag.ig_ho }}. hónap</span></div>
      <div class="tabla-wrap">
        <table class="n-racs">
          <thead><tr><th>Munkavállaló</th><th class="num">Előző évi</th><th class="num">Adott évi</th><th class="num">Keret</th>
            <th class="num cs-penz">Kivett (időszak)</th><th class="num">Kivett (év)</th><th class="num">Kiadható</th>
            <th class="num">Betegszab. keret</th><th class="num cs-penz">Betegszab. (időszak)</th><th class="num">Betegszab. (év)</th><th class="num">Betegszab. maradt</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of adat.szabadsag.sorok">
              <td><b>{{ r.nev }}</b></td>
              <td class="num">{{ r.elozo | number:'1.0-1' }}</td><td class="num">{{ r.adott | number:'1.0-1' }}</td><td class="num">{{ r.keret | number:'1.0-1' }}</td>
              <td class="num cs-penz"><b>{{ r.kivett_idoszak | number:'1.0-1' }}</b></td><td class="num">{{ r.kivett_ev | number:'1.0-1' }}</td>
              <td class="num" [class.neg]="r.kiadhato < 0">{{ r.kiadhato | number:'1.0-1' }}</td>
              <td class="num">{{ r.beteg_keret | number:'1.0-1' }}</td><td class="num cs-penz">{{ r.beteg_idoszak | number:'1.0-1' }}</td>
              <td class="num">{{ r.beteg_ev | number:'1.0-1' }}</td><td class="num" [class.neg]="r.beteg_maradt < 0">{{ r.beteg_maradt | number:'1.0-1' }}</td>
            </tr>
          </tbody>
          <tfoot><tr><td>Összesen</td>
            <td class="num">{{ szabOssz('elozo') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('adott') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('keret') | number:'1.0-1' }}</td>
            <td class="num">{{ szabOssz('kivett_idoszak') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('kivett_ev') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('kiadhato') | number:'1.0-1' }}</td>
            <td class="num">{{ szabOssz('beteg_keret') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('beteg_idoszak') | number:'1.0-1' }}</td>
            <td class="num">{{ szabOssz('beteg_ev') | number:'1.0-1' }}</td><td class="num">{{ szabOssz('beteg_maradt') | number:'1.0-1' }}</td></tr></tfoot>
        </table>
      </div>
      <p class="as-leiras">A keret a Munka Törvénykönyve szerint (alap + életkor, gyermekek, betegszabadság 15 nap, év közben arányosan), kézzel az Alkalmazotti törzsben írható felül; a kivett napok a jelenlétből.</p>
    </div>
    </div>

    <div class="n-panel as-info">
      <ion-icon name="information-circle-outline"></ion-icon>
      <div>
        <p><b>Adóalap-kedvezmény</b>: az adóalapot csökkentő mentességek és kedvezmények együtt (25 év alatti, anyák, személyi, első házas, családi).
          <ng-container *ngIf="adat.osszesen.nem_szja"> Az <b>SZJA-mentes jogcím</b> oszlop az SZJA-alapba nem tartozó bérelemek összege.</ng-container></p>
        <p>A havi bontású éves összesítő a <b>Bérösszesítő (havi bontásban)</b> menüpontban van. Az átalányadós egyéni vállalkozók elszámolása nem bér, ezért itt nem szerepel.</p>
      </div>
    </div>
  </ng-container>
</ng-container>
